import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useCountdown } from 'usehooks-ts';
type UseAutoAdvanceArgs = {
  seconds: number;
  enabled: boolean;
  /** Holds the count at its first value, for stories and previews. */
  paused?: boolean;
  onDone: () => void;
};
export const useAutoAdvance = t0 => {
  const $ = _c(18);
  const {
    seconds,
    enabled,
    paused: t1,
    onDone
  } = t0;
  const paused = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== seconds) {
    t2 = {
      countStart: seconds
    };
    $[0] = seconds;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [count, t3] = useCountdown(t2);
  const {
    startCountdown,
    stopCountdown
  } = t3;
  const doneRef = useRef(false);
  const stoppedRef = useRef(false);
  let t4;
  let t5;
  if ($[2] !== enabled || $[3] !== paused || $[4] !== startCountdown || $[5] !== stopCountdown) {
    t4 = () => {
      if (!enabled || paused) {
        return;
      }
      const sync = () => document.hidden || stoppedRef.current ? stopCountdown() : startCountdown();
      sync();
      document.addEventListener("visibilitychange", sync);
      return () => {
        document.removeEventListener("visibilitychange", sync);
        stopCountdown();
      };
    };
    t5 = [enabled, paused, startCountdown, stopCountdown];
    $[2] = enabled;
    $[3] = paused;
    $[4] = startCountdown;
    $[5] = stopCountdown;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== count || $[9] !== enabled || $[10] !== onDone) {
    t6 = () => {
      if (enabled && count === 0 && !doneRef.current) {
        doneRef.current = true;
        onDone();
      }
    };
    t7 = [enabled, count, onDone];
    $[8] = count;
    $[9] = enabled;
    $[10] = onDone;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  if ($[13] !== stopCountdown) {
    t8 = () => {
      stoppedRef.current = true;
      stopCountdown();
    };
    $[13] = stopCountdown;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const stop = t8;
  let t9;
  if ($[15] !== count || $[16] !== stop) {
    t9 = {
      count,
      stop
    };
    $[15] = count;
    $[16] = stop;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};